import { StageDefinition } from './StageDefinition';

export const stage02: StageDefinition = {
    platforms: [],
    traps: [
        [92.9032258064516, 0],
        [104.51612903225805, 0],
        [116.1290322580645, 0],
    ],
    stars: [
        [50, 1],
        [69, 2],
        [86, 3],
        [103, 4],
        [118, 3],
        [137, 2],
        [158, 1],
        [190, 0],
    ],
};
